import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddFaq() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.question.trim()) {
      toast.error("Please enter a question");
      return;
    }

    if (!formData.answer.trim()) {
      toast.error("Please enter an answer");
      return;
    }

    setLoading(true);

    // Prepare data according to Postman body structure
    const faqData = {
      question: formData.question.trim(),
      answer: formData.answer.trim(),
    };

    console.log("FAQ Data:", faqData);

    try {
      const res = await HomeService.createFaq(faqData);
      if (res?.status) {
        toast.success("FAQ added successfully!");
        clearForm();
        navigate("/manage-faq");
      } else {
        toast.error(res?.message || "Failed to add FAQ.");
      }
    } catch (error) {
      toast.error("Failed to add FAQ.");
      console.error("Error adding FAQ:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      question: "",
      answer: "",
    });
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add FAQ
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Question Input */}
                <div className="col-md-12 mt-3">
                  <label htmlFor="question">
                    Question<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="question"
                    className="form-control"
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    placeholder="Enter FAQ question..."
                    required
                  />
                  <div className="form-text">
                    Enter the question that users frequently ask
                  </div>
                </div>

                {/* Answer Textarea */}
                <div className="col-md-12 mt-3">
                  <label htmlFor="answer">
                    Answer<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="answer"
                    className="form-control"
                    name="answer"
                    value={formData.answer}
                    onChange={handleChange}
                    rows="6"
                    placeholder="Enter detailed answer..."
                    required
                    style={{ height: "200px" }}
                  ></textarea>
                  <div className="form-text">
                    Provide a clear and detailed answer to the question
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding FAQ...
                      </>
                    ) : (
                      "Add FAQ"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-2"
                    style={{
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={clearForm}
                  >
                    Clear Form
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddFaq;
